import type { WorkOrderId } from 'cadenza/api-client/workorder-api';
import type { GeocodingProgressDialogResult } from 'cadenza/geocoding/geocoding-progress-dialog/geocoding-progress-dialog';
import { observeWithGeocodingProgressDialog } from 'cadenza/geocoding/geocoding-progress-dialog/open-geocoding-progress-dialog';
import type { ObjecttypeIdString } from 'cadenza/repository/model/objecttype-id';
import type { EnrichmentType } from 'cadenza/workbook/api/enrichment-type';
import { getGeocodingType, isGeocodingEnrichment } from 'cadenza/workbook/api/enrichment-type';
import { createEnrichmentProgressDialog } from 'cadenza/workbook/enrichment/enrichment-utils';

type EnrichmentResult = GeocodingProgressDialogResult;

export async function showEnrichmentProgressDialog<T extends EnrichmentType>(
  enrichmentType: T,
  enrichedObjecttypeId: ObjecttypeIdString,
  workOrderId: WorkOrderId,
): Promise<EnrichmentResult> {
  if (isGeocodingEnrichment(enrichmentType)) {
    const geocodingType = getGeocodingType(enrichmentType);
    return observeWithGeocodingProgressDialog(
      enrichedObjecttypeId,
      workOrderId,
      geocodingType,
      'enrichment-object-type-created',
    );
  } else {
    const enrichmentResult = await createEnrichmentProgressDialog(workOrderId);
    return { createdObjectTypeId: enrichmentResult.objecttypeId };
  }
}
